import { nanoid } from "@reduxjs/toolkit";

const nanoId = nanoid();
function filterFormat(filterField) {
  let format = null;
  switch (filterField) {
    case "Years":
      format = "YYYY";
      break;
    case "Financial Year":
      format = "FYyyyy-yy";
      break;
    case "Quarter":
      format = "Qx-Fyyyyy-yy";
      break;
    case "Month-year":
      format = "MMM-YY";
      break;
    case "Month":
      format = "MMMM";
      break;
    case "Week":
      format = "Wx";
      break;
    case "Weekday":
      format = "dddd";
      break;
    case "Date (date-month-year)":
      format = "dd-mm-yyyy";
      break;
    case "Date (month-date-year)":
      format = "mm-dd-yyyy";
      break;
    case "'RangeOfDate'":
      format = "DD/MM/YYYY";
      break;
    default:
      console.log("Filter is null or has an incorrect value");
      format = null; // Explicitly set the format to null for unsupported values
      break;
  }
  return format;
}

const handleClicked = ({
  data,
  index,
  event,
  requiredArray,
  hoverIndex,
  dispatch,
  deleteTemporaryFilters,
  setFiltersToOtherSheets,
  Sheetid,
  clickedCaption,
  setClickedCaption,
  activeIndex,
  setActiveIndex,
  vizType,
  rawRowKeys,
  whatShouldDispatch,
  barIndex,
  stackedIndex,
  barClickedValue,
  stackClickedValue,
  stackActiveIndex,
  setStackActiveIndex,
  activeBarIndex,
  setActiveBarIndex,
  clickedValues,
  setClickedValues,
  properties,
  filterArray: reduxFilterArray,
  dataSourceID,
}) => {
  console.log(vizType);
  console.log(requiredArray);
  console.log(data);
  console.log(properties);
  console.log(clickedCaption);
  console.log(stackActiveIndex);
  console.log(activeBarIndex);
  let clickedValue;

  switch (vizType) {
    case "piechart":
      clickedValue = data.tooltipPayload.map((item) => item.name).flat();
      break;

    case "stackedbarchart":
    case "stackedbarchartimage":
      clickedValue = data;
      break;

    case "linechart":
      // console.log(data.points[0]);
      // console.log(data.points[0].payload);
      console.log(rawRowKeys);
      if (rawRowKeys.length === 1) {
        const partBeforePipe = data[hoverIndex]
          ? data[hoverIndex].split("|")[0]
          : undefined;
        console.log(partBeforePipe);

        clickedValue = [partBeforePipe];
      } else {
        clickedValue = [];
      }
      break;

    case "areachart":
      console.log(hoverIndex);
      console.log(data);
      console.log(data[index]);

      const partBeforePipeArea = data[index]
        ? data[index].split("|")[0]
        : undefined;
      console.log(partBeforePipeArea);
      clickedValue = [partBeforePipeArea];
      break;

    case "scatterchart":
      if (requiredArray.length === 1) {
        clickedValue = [data[`${requiredArray[0].responseKey}`]];
      } else {
        clickedValue = [];
      }
      break;

    default:
      clickedValue = [];
      break;
  }
  console.log(clickedValue);

  const isCtrlPressed = event.ctrlKey || event.metaKey;
  const { columnName, dataType, uuid, caption, nanoId, columnType, formula } =
    requiredArray?.[0] || {};
  // console.log({ columnName, dataType, uuid, caption });
  console.log(vizType);
  console.log(!["stackedbarchart", "stackedbarchartimage"].includes(vizType));
  console.log(Array.isArray(clickedValue) && clickedValue.length > 0);

  if (!["stackedbarchart", "stackedbarchartimage"].includes(vizType)) {
    if (Array.isArray(clickedValue) && clickedValue.length > 0) {
      let newCaption, newIndex;
      if (isCtrlPressed && clickedCaption !== undefined) {
        console.log("if condition ran");
        if (
          Array.isArray(clickedCaption) &&
          clickedCaption.includes(clickedValue[0])
        ) {
          newCaption = clickedCaption.filter(
            (item) => item !== clickedValue[0]
          );
          if (newCaption.length === 0) {
            dispatch(
              deleteTemporaryFilters({
                sourceSheet: Sheetid,
                allTempFiltersBoolean: false,
              })
            );
          } else {
            dispatch(
              setFiltersToOtherSheets({
                columnName,
                rename: caption,
                dataType,
                uuid,
                Sheetid,
                selectedOperator: "IN",
                selectedFilterValues: newCaption,
                nanoId: nanoId,
                filterType: properties?.filterType || "temporary",
                vizType,
                properties,
                dataSourceID,
                nanoId,
                columnType,
                formula,
              })
            );
          }
        } else {
          console.log("dede");

          newCaption = [...clickedCaption, ...clickedValue];
          dispatch(
            setFiltersToOtherSheets({
              columnName,
              rename: caption,
              dataType,
              uuid,
              Sheetid,
              selectedOperator: "IN",
              selectedFilterValues: newCaption,
              nanoId: nanoId,
              filterType: properties?.filterType || "temporary",
              vizType,
              properties,
              nanoId,
              dataSourceID,
              columnType,
              formula,
            })
          );
        }
      } else {
        console.log("else condition ran");
        if (
          Array.isArray(clickedCaption) &&
          clickedCaption.includes(clickedValue[0]) &&
          clickedCaption.length === 1 &&
          clickedCaption[0] === clickedValue[0]
        ) {
          newCaption = [];
          dispatch(
            deleteTemporaryFilters({
              sourceSheet: Sheetid,
              allTempFiltersBoolean: false,
            })
          );
        } else {
          newCaption = clickedValue;
          // console.log({ columnName, dataType, uuid, caption });
          console.log({
            columnName,
            rename: caption,
            dataType,
            uuid,
            Sheetid,
            selectedOperator: "IN",
            selectedFilterValues: newCaption,
            nanoId: nanoId,
            filterType: properties?.filterType || "temporary",
            vizType,
            properties,
            nanoId,
            dataSourceID,
            columnType,
            formula,
          });

          dispatch(
            setFiltersToOtherSheets({
              columnName,
              rename: caption,
              dataType,
              uuid,
              Sheetid,
              selectedOperator: "IN",
              selectedFilterValues: newCaption,
              nanoId: nanoId,
              filterType: properties?.filterType || "temporary",
              vizType,
              properties,
              dataSourceID,
              nanoId,
              columnType,
              formula,
            })
          );
        }
      }
      if (isCtrlPressed && activeIndex !== undefined) {
        if (Array.isArray(activeIndex) && activeIndex.includes(index)) {
          newIndex = activeIndex.filter((i) => i !== index);
        } else {
          newIndex = [...activeIndex, index];
        }
      } else {
        if (
          Array.isArray(activeIndex) &&
          activeIndex.includes(index) &&
          activeIndex.length === 1 &&
          activeIndex[0] === index
        ) {
          newIndex = [];
        } else {
          newIndex = [index];
        }
      }

      setClickedCaption(newCaption);
      console.log(newCaption);
      setActiveIndex(newIndex);
      console.log(newIndex);
    } else {
      console.error("may be clicked value array is empty");
    }
  } else {
    console.log("vizType is stackedbarchart");
    let rowfilterObject;
    let groupfilterObject;
    console.log(whatShouldDispatch);
    function dispatchableFilterArrayIs({
      whatShouldDispatch,
      barIndex,
      stackedIndex,
      barClickedValue,
      stackClickedValue,
      requiredArray,
      rawRowKeys,
      properties,
    }) {
      const {
        responseKey: groupResponseKey,
        caption: groupCaption,
        rename: groupRename,
        dataType: groupDataType,
        uuid: groupUuid,
        columnName: groupColumnName,
        format: groupFormat,
        nanoId: groupNanoId,
        columnType: groupColumnType,
        formula: groupFormula,
      } = requiredArray[0] !== undefined && requiredArray[0];
      const {
        responseKey: rowResponseKey,
        caption: rowCaption,
        rename: rowRename,
        dataType: rowDataType,
        uuid: rowUuid,
        columnName: rowColumnName,
        format: rowFormat,
        nanoId: rawNanoId,
        columnType: rawColumnType,
        formula: rawFormula,
      } = rawRowKeys !== undefined && rawRowKeys[0] !== undefined
        ? rawRowKeys[0]
        : [];
      groupfilterObject = {
        columnName: groupColumnName,
        rename: groupCaption,
        dataType: groupDataType,
        Sheetid,
        selectedOperator: "IN",
        format: groupFormat,
        uuid: groupUuid,
        selectedFilterValues: [],
        nanoId: groupNanoId,
        dataSourceID,
        filterType:
          properties !== undefined ? properties?.filterType : "temporary",
        columnType: groupColumnType,
        formula: groupFormula,
      };
      rowfilterObject = {
        columnName: rowColumnName,
        rename: rowCaption,
        dataType: rowDataType,
        Sheetid,
        selectedOperator: "IN",
        format: rowFormat,
        uuid: rowUuid,
        selectedFilterValues: [],
        nanoId: rawNanoId,
        dataSourceID,
        filterType:
          properties !== undefined ? properties?.filterType : "temporary",
        columnType: rawColumnType,
        formula: rawFormula,
      };
      let groupUpdatedSelectedFilterValue;
      let rowUpdatedSelectedFilterValue;
      let xAxisIndex;
      let yAxisIndex;
      const { barClickedCaption, stackClickedCaption } = clickedValues;
      console.log(whatShouldDispatch);
      if (whatShouldDispatch === "xAxisValue") {
        console.log(whatShouldDispatch);
        // Calculate groupUpdatedSelectedFilterValue before setClickedValues
        if (isCtrlPressed) {
          groupUpdatedSelectedFilterValue =
            clickedValues.barClickedCaption?.includes(barClickedValue)
              ? clickedValues.barClickedCaption.filter(
                  (value) => value !== barClickedValue
                )
              : [...(clickedValues.barClickedCaption || []), barClickedValue];
          xAxisIndex = activeBarIndex?.includes(barIndex)
            ? activeBarIndex.filter((value) => value !== barIndex)
            : [...(activeBarIndex || []), barIndex];
        } else {
          groupUpdatedSelectedFilterValue = [barClickedValue];
          xAxisIndex = [barIndex];
        }

        // Use groupUpdatedSelectedFilterValue in setClickedValues
        const isPrevoiusBarClickedAgain =
          activeBarIndex.length === 1 &&
          barClickedCaption !== undefined &&
          barClickedCaption.length === 1
            ? activeBarIndex[0] === barIndex &&
              barClickedCaption[0] === barClickedValue
              ? true
              : false
            : false;
        console.log(isPrevoiusBarClickedAgain);

        if (isPrevoiusBarClickedAgain) {
          console.log("bar array is empty");
          console.log(groupUpdatedSelectedFilterValue);
          setActiveBarIndex([]);
          setClickedValues({
            barClickedCaption: [],
            stackClickedCaption: [],
          });
          groupUpdatedSelectedFilterValue = [];
        } else {
          console.log("bar array not empty");
          setActiveBarIndex(xAxisIndex);
          setClickedValues({
            barClickedCaption: groupUpdatedSelectedFilterValue,
            stackClickedCaption: [],
          });
        }
        console.log(groupUpdatedSelectedFilterValue);

        const updateGroupFilterValue = {
          ...groupfilterObject,
          selectedFilterValues: groupUpdatedSelectedFilterValue,
        };
        // Update groupfilterObject using groupUpdatedSelectedFilterValue
        console.log(updateGroupFilterValue);

        return (groupfilterObject =
          groupUpdatedSelectedFilterValue !== undefined &&
          groupUpdatedSelectedFilterValue.length > 0
            ? [updateGroupFilterValue]
            : []);
      } else if (whatShouldDispatch === "xAxisValue&StackValue") {
        console.log(whatShouldDispatch);
        // Calculate groupUpdatedSelectedFilterValue and rowUpdatedSelectedFilterValue first
        if (isCtrlPressed) {
          groupUpdatedSelectedFilterValue = [barClickedValue];

          rowUpdatedSelectedFilterValue =
            clickedValues.stackClickedCaption?.includes(stackClickedValue)
              ? clickedValues.stackClickedCaption.filter(
                  (value) => value !== stackClickedValue
                )
              : [
                  ...(clickedValues.stackClickedCaption || []),
                  stackClickedValue,
                ];
          xAxisIndex = activeBarIndex?.includes(barIndex)
            ? activeBarIndex.filter((value) => value !== barIndex)
            : [...(activeBarIndex || []), barIndex];
          yAxisIndex = stackActiveIndex?.includes(stackedIndex)
            ? stackActiveIndex.filter((value) => value !== stackedIndex)
            : [...(stackActiveIndex || []), stackedIndex];
        } else {
          groupUpdatedSelectedFilterValue = [barClickedValue];
          rowUpdatedSelectedFilterValue = [stackClickedValue];
          xAxisIndex = [barIndex];
          yAxisIndex = [stackedIndex];
        }

        const isPrevoiusBarClickedAgain =
          activeBarIndex.length === 1 &&
          barClickedCaption !== undefined &&
          barClickedCaption.length === 1
            ? activeBarIndex[0] === barIndex &&
              barClickedCaption[0] === barClickedValue
              ? true
              : false
            : false;
        const isPrevoiusStackClickedAgain =
          stackActiveIndex.length === 1 &&
          stackClickedCaption !== undefined &&
          stackClickedCaption.length === 1
            ? stackActiveIndex[0] === stackedIndex &&
              stackClickedCaption[0] === stackClickedValue
              ? true
              : false
            : false;

        if (isPrevoiusBarClickedAgain && isPrevoiusStackClickedAgain) {
          console.log("bar and stack array is empty");
          setActiveBarIndex([]);
          setStackActiveIndex([]);
          setClickedValues({
            barClickedCaption: [],
            stackClickedCaption: [],
          });
          groupUpdatedSelectedFilterValue = [undefined];
          rowUpdatedSelectedFilterValue = [undefined];
        } else {
          console.log("bar and array not empty");
          setActiveBarIndex(xAxisIndex);
          setStackActiveIndex(yAxisIndex);
          setClickedValues({
            barClickedCaption: groupUpdatedSelectedFilterValue,
            stackClickedCaption: rowUpdatedSelectedFilterValue,
          });
        }
        const updateGroupFilterValue = {
          ...groupfilterObject,
          selectedFilterValues: groupUpdatedSelectedFilterValue,
        };

        const updateRowFilterValue = {
          ...rowfilterObject,
          selectedFilterValues: rowUpdatedSelectedFilterValue,
        };
        console.log(groupUpdatedSelectedFilterValue);

        console.log(rowUpdatedSelectedFilterValue);

        groupfilterObject = updateGroupFilterValue;
        rowfilterObject = updateRowFilterValue;

        return [groupfilterObject, rowfilterObject];
      } else {
        return [];
      }
    }

    let filterArray =
      requiredArray.length > 0 ||
      (requiredArray.length > 0 && rawRowKeys.length > 0)
        ? dispatchableFilterArrayIs({
            whatShouldDispatch,
            barIndex,
            stackedIndex,
            barClickedValue,
            stackClickedValue,
            requiredArray,
            rawRowKeys,
            properties,
          })
        : [];

    console.log(filterArray);
    dispatch(
      setFiltersToOtherSheets({
        columnName: null,
        rename: null,
        dataType: null,
        uuid: null,
        selectedSheetId: null,
        selectedOperator: null,
        selectedFilterValues: [],
        nanoId: null,
        filterType: null,
        vizType,
        filterArray: filterArray,
        properties,
      })
    );
  }
};
const CalculateAction = ({
  data,
  index,
  event,
  requiredArray,
  hoverIndex,
  dispatch,
  deleteTemporaryFilters,
  setFiltersToOtherSheets,
  Sheetid,
  clickedCaption,
  setClickedCaption,
  activeIndex,
  setActiveIndex,
  vizType,
  rawRowKeys,
  whatShouldDispatch,
  barIndex,
  stackedIndex,
  barClickedValue,
  stackClickedValue,
  stackActiveIndex,
  setStackActiveIndex,
  activeBarIndex,
  setActiveBarIndex,
  clickedValues,
  setClickedValues,
  setWorkbookProperty,
  actionsProperty,
  workbookId,
  workbookType,
  navigate,
  handleTargetSheetQuery,
  dataSourceID,
  sheetsArray,
  roles,
}) => {
  console.log(activeIndex);

  const handleFilter = (properties) => {
    console.log("Handling filter action", properties);
    const Sheetid = properties.sourceSheet.Sheetid;
    if (properties.isAllSheets) {
      console.log("Applying filters to all sheets");
    } else {
      console.log("Applying filters to target sheets");
    }
    handleClicked({
      data,
      index,
      event,
      requiredArray,
      hoverIndex,
      dispatch,
      deleteTemporaryFilters,
      setFiltersToOtherSheets,
      Sheetid,
      clickedCaption,
      setClickedCaption,
      activeIndex,
      setActiveIndex,
      activeBarIndex,
      setActiveBarIndex,
      vizType,
      rawRowKeys,
      whatShouldDispatch,
      barIndex,
      stackedIndex,
      barClickedValue,
      stackClickedValue,
      stackActiveIndex,
      setStackActiveIndex,
      activeBarIndex,
      setActiveBarIndex,
      clickedValues,
      setClickedValues,
      setWorkbookProperty,
      properties,
      dataSourceID,
    });
  };

  const handleSheetChange = (properties) => {
    const targetSheetid = properties
      ? properties?.targetSheets[0]?.Sheetid
      : null;

    const Sheetid = properties.sourceSheet.Sheetid;
    console.log(workbookType);
    if (workbookType === "draft") {
      //  handleTargetSheetQuery(targetSheetid);
      dispatch(
        setWorkbookProperty({
          itemInArray: false,
          key: "selectedSheetId",
          value: targetSheetid,
        })
      );
    } else {
      console.log(workbookId);
      if (roles.includes("Guest")) {
        navigate(
          `/publicdashboard?workbookid=${workbookId}&sheetid=${targetSheetid}`
        );
      } else {
        navigate(
          `/dashboard?workbookid=${workbookId}&sheetid=${targetSheetid}`
        );
      }
      dispatch(
        setWorkbookProperty({
          itemInArray: false,
          key: "selectedSheetId",
          value: targetSheetid,
        })
      );
    }
    console.log(sheetsArray);
    const currentSheet = sheetsArray.find((sheet) => sheet.ID === Sheetid);
    const targetSheet = sheetsArray.find((sheet) => sheet.ID === targetSheetid);
    const currentSheetDataSourceID = currentSheet.dataSourceID;
    const targetSheetDataSourceID = targetSheet.dataSourceID;
    console.log(currentSheetDataSourceID === targetSheetDataSourceID);
    if (currentSheetDataSourceID === targetSheetDataSourceID) {
      handleClicked({
        data,
        index,
        event,
        requiredArray,
        hoverIndex,
        dispatch,
        deleteTemporaryFilters,
        setFiltersToOtherSheets,
        Sheetid,
        clickedCaption,
        setClickedCaption,
        activeIndex,
        setActiveIndex,
        activeBarIndex,
        setActiveBarIndex,
        vizType,
        rawRowKeys,
        whatShouldDispatch,
        barIndex,
        stackedIndex,
        barClickedValue,
        stackClickedValue,
        stackActiveIndex,
        setStackActiveIndex,
        activeBarIndex,
        setActiveBarIndex,
        clickedValues,
        setClickedValues,
        setWorkbookProperty,
        properties,
        dataSourceID,
      });
    } else {
      console.error(
        "dataSourceID of target sheet is different from source sheet dataSourceID thats why filter will not apply on target sheet"
      );
    }
  };

  const handleGoToLink = (properties) => {
    console.log("Handling GoToURL action", properties);
    window.open(`${properties.link}`, "_blank");
  };

  if (actionsProperty) {
    console.log(actionsProperty.action, actionsProperty);
    switch (actionsProperty.action) {
      case "Filters":
        handleFilter(actionsProperty);
        break;
      case "GoToSheet":
        handleSheetChange(actionsProperty);
        break;
      case "GoToURL":
        handleGoToLink(actionsProperty);
        break;
      default:
        console.log("Unknown action:", actionsProperty.action);
    }
  } else {
    console.error("actionsProperty is undefined");
  }
};

export { CalculateAction, handleClicked };
